module.exports = __webpack_public_path__ + "static/3-a14991f7e468f337d25df8b97ce8598e.jpeg";